<div class="card">
  <div class="card-title">
    <span>Shortage Change Logs</span>
    <span *ngIf="isLoading" class="loader-sm" style="margin-left:10px;"></span>
  </div>
  <div class="filter-bar">
    <div class="filter-group search-group">
      <label>Search</label>
      <div class="input-container">
        <input type="text" [(ngModel)]="searchQuery" (keyup.enter)="handleFilterChange()"
          placeholder="Search brand name, NDA, NDC...">
        <i class="pi pi-search search-icon"></i>
      </div>
    </div>

    <div class="filter-group">
      <label>Filter Type</label>
      <select [(ngModel)]="changelogTypeFilter" (change)="handleFilterChange()">
        <option value="updated">Updated Records</option>
        <option value="new">New Records</option>
      </select>
    </div>

    <div class="filter-group">
      <label>Status</label>
      <select [(ngModel)]="selectedStatus" (change)="handleFilterChange()">
        <option value="">All Statuses</option>
        <option value="Current">Current</option>
        <option value="Discontinued">Discontinued</option>
      </select>
    </div>

    <div class="filter-group">
      <label>Date From</label>
      <input type="date" [(ngModel)]="dateFrom" (change)="handleFilterChange()">
    </div>

    <div class="filter-group">
      <label>Date To</label>
      <input type="date" [(ngModel)]="dateTo" (change)="handleFilterChange()">
    </div>

    <div class="filter-group filter-actions">
      <label>&nbsp;</label>
      <div class="buttons-container">
        <button type="button" class="btn btn-primary btn-search" (click)="handleFilterChange()" title="Search">
          <i class="pi pi-search"></i> Search
        </button>
        <button type="button" class="btn btn-secondary btn-reset" (click)="resetFilters()" title="Reset Filters">
          <i class="pi pi-refresh"></i> Reset
        </button>
      </div>
    </div>
  </div>

  <div class="table-wrap" [class.loading-opacity]="isLoading">
    <table>
      <thead>
        <tr>
          <th style="width: 50px; text-align: center;"></th>
          <th>NDA</th>
          <th>Brand Name</th>
          <th>Company</th>
          <th>NDCs Count</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let item of changelogData">
          <tr class="group-row clickable-row" [class.expanded]="item.isExpanded" (click)="toggleRow(item)">
            <td style="text-align: center;">
              <button type="button" class="toggle-btn" [class.expanded]="item.isExpanded">
                <i class="pi" [ngClass]="item.isExpanded ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
              </button>
            </td>
            <td>{{item.nda || 'N/A'}}</td>
            <td><b>{{item.brand_name || 'N/A'}}</b></td>
            <td>{{getCompanyNames(item)}}</td>
            <td>
              <span style="color: var(--primary); font-size: 11px; font-weight: 700;">{{item.ndcs?.length || 0}} NDC{{(item.ndcs?.length || 0) > 1 ? 's' :
                ''}}</span>
            </td>
          </tr>

          <!-- Expanded Nested Table Row -->
          <tr *ngIf="item.isExpanded" class="nested-row">
            <td colspan="5" style="padding: 0;">
              <div class="nested-table-container">
                <table class="nested-table">
                  <thead>
                    <tr>
                      <th>Strength</th>
                      <th *ngIf="hasMultipleCompanies(item)">Company</th>
                      <th>NDC</th>
                      <th>Update Type</th>
                      <th>Date</th>
                      <th>Status</th>
                      <th style="text-align: center; width: 80px;">History</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let ndc of item.ndcs">
                      <td>{{ndc.strength || 'N/A'}}</td>
                      <td *ngIf="hasMultipleCompanies(item)">
                        {{ndc.previous_record?.company_name || ndc.latest_record?.company_name || 'N/A'}}
                      </td>
                      <td style="min-width: 150px;">
                        <span class="ndc-link" (click)="openNdcDetailsModal(ndc, item, $event)">
                          {{ndc.ndc || 'N/A'}}
                        </span>
                      </td>
                      <td>
                        <span [style.color]="ndc.latest_record?.type_of_update === 'New' ? '#16a34a' : '#2563eb'"
                          style="font-size: 11px; font-weight: 700;">
                          {{ndc.latest_record?.type_of_update || 'N/A'}}
                        </span>
                      </td>
                      <td>{{ndc.latest_record?.created_at | date:'dd-MM-yyyy'}}</td>
                      <td>
                        <span [style.color]="ndc.latest_record?.status === 'Current' ? '#dc2626' : '#16a34a'"
                          style="font-size: 11px; font-weight: 700;">
                          {{ndc.latest_record?.status || 'N/A'}}
                        </span>
                      </td>
                      <td style="text-align: center;">
                        <button type="button" class="btn-icon" (click)="openChangesModal(ndc, $event)"
                          [disabled]="!ndc.changes || ndc.changes.length === 0"
                          [title]="ndc.changes && ndc.changes.length > 0 ? 'View changes history' : 'No changes history'">
                          <i class="pi pi-clock"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </ng-container>
        <tr *ngIf="changelogData.length === 0 && !isLoading">
          <td colspan="5" style="text-align:center; padding: 40px; color: var(--text-muted);">No records found matching
            filters.</td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- PAGINATION -->
  <div class="pagination-footer" *ngIf="totalPages > 0">
    <div class="pagination-controls">
      <button (click)="goToPage(1)" [disabled]="currentPage === 1" class="page-btn symbol" title="First Page">«</button>
      <button (click)="goToPage(currentPage - 1)" [disabled]="currentPage === 1" class="page-btn symbol"
        title="Previous">‹</button>

      <button *ngFor="let p of getVisiblePages()" (click)="goToPage(p)" class="page-btn"
        [class.active]="p === currentPage">
        {{p}}
      </button>

      <button (click)="goToPage(currentPage + 1)" [disabled]="currentPage === totalPages" class="page-btn symbol"
        title="Next">›</button>
      <button (click)="goToPage(totalPages)" [disabled]="currentPage === totalPages" class="page-btn symbol"
        title="Last Page">»</button>

      <select [(ngModel)]="pageSize" (change)="handlePageSizeChange()" class="page-size-select">
        <option [value]="10">10</option>
        <option [value]="20">20</option>
        <option [value]="50">50</option>
        <option [value]="100">100</option>
      </select>
    </div>

    <div class="total-records">
      Total Records : {{totalRecords | number}}
    </div>
  </div>

  <!-- Modal Popup for Changes History -->
  <div class="modal-overlay" *ngIf="showChangesModal" (click)="closeChangesModal()">
    <div class="modal-card" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>Changes History (NDC: {{selectedNdc}})</h3>
        <button class="modal-close-btn" (click)="closeChangesModal()">
          <i class="pi pi-times"></i>
        </button>
      </div>
      <div class="modal-body">
        <div *ngIf="selectedChanges && selectedChanges.length > 0; else noChangesTemp">
          <table class="modal-table">
            <thead>
              <tr>
                <th>Field</th>
                <th>Old Value</th>
                <th>New Value</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let change of selectedChanges">
                <td class="field-name"><b>{{formatFieldName(change.field)}}</b></td>
                <td>
                  <span class="change-val old-val">{{change.old_value || 'N/A'}}</span>
                </td>
                <td>
                  <span class="change-val new-val">{{change.new_value || 'N/A'}}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <ng-template #noChangesTemp>
          <div class="no-changes-msg">
            <i class="pi pi-info-circle"></i> No changes history recorded for this NDC.
          </div>
        </ng-template>
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary" (click)="closeChangesModal()">Close</button>
      </div>
    </div>
  </div>

  <!-- Modal Popup for NDC Details -->
  <div class="modal-overlay" *ngIf="showNdcDetailsModal" (click)="closeNdcDetailsModal()">
    <div class="modal-card" (click)="$event.stopPropagation()" style="max-width: 800px; width: 90%; max-height: 90vh;">
      <div class="modal-header">
        <h3 style="margin: 0; color:var(--primary); font-size: 18px; font-weight: 600;">NDC Details</h3>
        <button class="modal-close-btn" (click)="closeNdcDetailsModal()">
          <i class="pi pi-times"></i>
        </button>
      </div>
      <div class="modal-body" style="padding: 24px; overflow-y: auto;">
        <!-- Product/Group Level Info -->
        <div
          style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 16px 24px; margin-bottom: 24px; padding-bottom: 20px; border-bottom: 1px solid #f1f5f9;">
          <div>
            <div
              style="font-size: 11px; color: var(--text-muted); font-weight: 700; text-transform: uppercase; margin-bottom: 4px;">
              Brand Name</div>
            <div style="font-weight: 700; font-size: 15px; color: #334155; text-transform: uppercase;">
              {{selectedNdcParent?.brand_name || 'N/A'}}</div>
          </div>
          <div>
            <div
              style="font-size: 11px; color: var(--text-muted); font-weight: 700; text-transform: uppercase; margin-bottom: 4px;">
              NDA</div>
            <div style="font-weight: 700; font-size: 15px; color: #334155;">{{selectedNdcParent?.nda || 'N/A'}}</div>
          </div>
          <div>
            <div
              style="font-size: 11px; color: var(--text-muted); font-weight: 700; text-transform: uppercase; margin-bottom: 4px;">
              Dosage Form</div>
            <div style="font-weight: 700; font-size: 15px; color: #334155; text-transform: uppercase;">
              {{formatArrayOrString(selectedNdcDetails?.dosage_forms || selectedNdcParent?.summary?.dosage_forms ||
              selectedNdcParent?.dosage_forms)}}
            </div>
          </div>
          <div>
            <div
              style="font-size: 11px; color: var(--text-muted); font-weight: 700; text-transform: uppercase; margin-bottom: 4px;">
              Route</div>
            <div style="font-weight: 700; font-size: 15px; color: #334155; text-transform: uppercase;">
              {{formatArrayOrString(selectedNdcDetails?.route || selectedNdcParent?.summary?.routes ||
              selectedNdcParent?.route)}}
            </div>
          </div>
        </div>

        <!-- NDC Details Card style -->
        <div
          style="border: 1px solid #eef2f6; border-radius: 12px; overflow: hidden; box-shadow: 0 1px 3px rgba(0,0,0,0.02); margin-bottom: 16px;">
          <!-- NDC Header -->
          <div
            style="background: #f8fafc; padding: 14px 20px; display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid #eef2f6;">
            <div style="display: flex; gap: 24px; align-items: center; flex-wrap: wrap;">
              <div>
                <span
                  style="font-size: 11px; color: var(--text-muted); font-weight: 700; text-transform: uppercase; display: block; margin-bottom: 2px;">NDC
                  Number</span>
                <span style="font-weight: 700; font-size: 14px; color: #334155;">{{selectedNdcDetails?.ndc}}</span>
              </div>
              <div>
                <span
                  style="font-size: 11px; color: var(--text-muted); font-weight: 700; text-transform: uppercase; display: block; margin-bottom: 2px;">Strength</span>
                <span style="font-weight: 700; font-size: 14px; color: #334155;">{{selectedNdcDetails?.strength ||
                  'N/A'}}</span>
              </div>
            </div>
            <div>
              <span [style.color]="getVal(selectedNdcDetails?.latest_record?.status) === 'Current' ? '#dc2626' : '#16a34a'"
                style="font-size: 11px; font-weight: 700;">
                {{getVal(selectedNdcDetails?.latest_record?.status)}}
              </span>
            </div>
          </div>

          <!-- NDC Detail Body -->
          <div style="padding: 20px; background: #fff;">
            <div
              style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px; flex-wrap: wrap; gap: 12px;">
              <h4 style="font-weight: 700; font-size: 16px; color: var(--primary); margin: 0;">
                {{getVal(selectedNdcDetails?.latest_record?.company_name) ||
                getVal(selectedNdcDetails?.previous_record?.company_name)}}
              </h4>
              <div style="display: flex; align-items: center; gap: 8px;">
                <span style="font-size: 13px; color: #64748b;">Date of Update:</span>
                <span style="color: #2563eb; font-size: 11px; font-weight: 700;">
                  {{getFormattedDate(selectedNdcDetails?.latest_record?.date_of_update) ||
                  getFormattedDate(selectedNdcDetails?.latest_record?.created_at)}}
                </span>
              </div>
            </div>

            <!-- 2 Column Details Grid -->
            <div
              style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 16px 32px; margin-bottom: 20px; font-size: 13px;">
              <div style="display: flex; align-items: center; flex-wrap: wrap;">
                <span style="font-weight: 700; color: #334155;">Generic Name:</span>
                <span
                  style="color: #475569; margin-left: 6px;">{{getVal(selectedNdcDetails?.latest_record?.generic_name)}}</span>
              </div>
              <div style="display: flex; align-items: center; flex-wrap: wrap;">
                <span style="font-weight: 700; color: #334155;">Update Type:</span>
                <span
                  style="color: #475569; margin-left: 6px;">{{getVal(selectedNdcDetails?.latest_record?.type_of_update)}}</span>
              </div>
              <div style="display: flex; align-items: center; flex-wrap: wrap;">
                <span style="font-weight: 700; color: #334155;">Date of Discontinued:</span>
                <span
                  style="color: #475569; margin-left: 6px;">{{getFormattedDate(selectedNdcDetails?.latest_record?.date_discontinued)}}</span>
              </div>
              <div style="display: flex; align-items: center; flex-wrap: wrap;">
                <span style="font-weight: 700; color: #334155;">Initial Posting Date:</span>
                <span
                  style="color: #475569; margin-left: 6px;">{{getFormattedDate(selectedNdcDetails?.latest_record?.initial_posting_date)}}</span>
              </div>
              <div style="display: flex; align-items: center; flex-wrap: wrap;">
                <span style="font-weight: 700; color: #334155;">Availability Info:</span>
                <span
                  style="color: #475569; margin-left: 6px;">{{getVal(selectedNdcDetails?.latest_record?.availability_information)}}</span>
              </div>
              <div style="display: flex; align-items: center; flex-wrap: wrap;">
                <span style="font-weight: 700; color: #334155;">Therapeutic Category:</span>
                <span
                  style="color: #475569; margin-left: 6px;">{{getVal(selectedNdcDetails?.latest_record?.therapeutic_category)}}</span>
              </div>
              <div style="display: flex; align-items: center; flex-wrap: wrap; grid-column: span 2;">
                <span style="font-weight: 700; color: #334155;">Presentation:</span>
                <span
                  style="color: #475569; margin-left: 6px;">{{getVal(selectedNdcDetails?.latest_record?.presentation)}}</span>
              </div>
              <div style="display: flex; align-items: center; flex-wrap: wrap; grid-column: span 2;"
                *ngIf="getVal(selectedNdcDetails?.latest_record?.resolved_note) !== 'N/A'">
                <span style="font-weight: 700; color: #334155;">Resolved Note:</span>
                <span
                  style="color: #475569; margin-left: 6px;">{{getVal(selectedNdcDetails?.latest_record?.resolved_note)}}</span>
              </div>
            </div>

            <!-- Description fields -->
            <div style="font-size: 13px; padding-top: 16px; border-top: 1px solid #eef2f6;">
              <div style="margin-bottom: 8px; display: flex; align-items: flex-start;">
                <span style="font-weight: 700; color: #334155; min-width: 150px; display: inline-block;">Reason of
                  Shortage:</span>
                <span
                  style="color: #64748b; flex: 1;">{{getVal(selectedNdcDetails?.latest_record?.reason_for_shortage)}}</span>
              </div>
              <div style="display: flex; align-items: flex-start;">
                <span style="font-weight: 700; color: #334155; min-width: 150px; display: inline-block;">Related
                  Information:</span>
                <span
                  style="color: #64748b; flex: 1;">{{getVal(selectedNdcDetails?.latest_record?.related_information)}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary" (click)="closeNdcDetailsModal()">Close</button>
      </div>
    </div>
  </div>
</div>